module.exports = __webpack_public_path__ + "static/linkedinLogo-07f346967c54232d1442589927c8f7dd.png";